import { faBullhorn } from '@fortawesome/pro-light-svg-icons'

import { digObject, formatDate } from '@domain-group/javascript-utils'

import {
  Box, DashboardModule, ListItem, Text,
} from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'
import useCampaigns from '@hooks/useCampaigns'
import useCurrentUser from '@hooks/useCurrentUser'
import { getCampaignPermissions } from '@functions/campaign'

export const icon = faBullhorn

export const configOptions = () => ({
  title: {
    component: 'input',
    key: 'title',
    label: 'Title',
    optionKey: 'customization',
  },
  limit: {
    component: 'select',
    key: 'limit',
    label: 'Limit',
    optionKey: 'queryParams',
    values: [
      { key: 5, label: '5' },
      { key: 10, label: '10' },
      { key: 25, label: '25' },
      { key: 50, label: '50' },
    ],
  },
})

interface AgencyMarketingProps {
  customOptions: {
    customization: {
      title?: string,
    },
    queryParams: {
      key?: string,
      limit?: number,
    },
  },
  editing: boolean,
}

const AgencyMarketing = (props: AgencyMarketingProps) => {
  const {
    customOptions: {
      customization,
      queryParams,
    },
    editing,
  } = props

  const campaignsPayload = useCampaigns({
    filters: {
      agency_marketing: 'true',
      hidden: 'false',
      ...queryParams,
    },
    performHttpRequests: true,
  })

  const {
    hasFilteredCampaigns,
    filteredCampaigns,
    loading,
  } = campaignsPayload

  const { title } = customization || {}

  const { currentUser } = useCurrentUser()

  const campaignPermissions = getCampaignPermissions({
    user: currentUser,
    campaignType: 'agency_marketing',
  })

  const agencyMarketingArray = filteredCampaigns.slice(0, queryParams.limit || 5)

  if (!loading && !hasFilteredCampaigns) return null

  return (
    <DashboardModule editing={editing} loading={loading} title={title || 'Marketing & Stationery'}>
      {!loading && hasFilteredCampaigns && (
        <DashboardModule.ScrollableSection>
          {agencyMarketingArray.map((campaign) => {
            const { campaignEditDashboardUrl, campaignQuotesUrl } = generateUrls({ id: campaign.id })
            const canManageCampaign = campaignPermissions?.orders?.manage || false
            const editUrl = canManageCampaign ? campaignEditDashboardUrl : campaignQuotesUrl
            const createdAt = digObject(campaign, 'dates.created.date_time')

            return (
              <ListItem
                boxProps={{ as: 'a', borderBottom: '1px solid', padding: 'large' }}
                href={editUrl}
                key={campaign.id}
                showAngleIcon
              >
                <Box
                  alignItems="center"
                  border="1px solid"
                  borderColor="blue"
                  borderRadius="5px"
                  justifyContent="center"
                  marginRight="large"
                  width={70}
                  key={campaign.id}
                >
                  <Text fontSize="small" color="blue">
                    AM
                  </Text>
                </Box>

                <Box justifyContent="center" flexDirection="column">
                  <Text fontSize="small">{campaign.title}</Text>
                  <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
                    {`Created ${formatDate(createdAt, 'dd/MM/yyyy HH:mm', "d LLL yyyy 'at' h:MM a")}`}
                  </Text>
                </Box>
              </ListItem>
            )
          })}
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default AgencyMarketing
